/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { SavePlanCommand } from '../../models/save-plan-command';

export interface ApiPlanSavePlanPatch$Params {
  
    /**
     * Plan Save command
     */
    body?: SavePlanCommand
}

export function apiPlanSavePlanPatch(http: HttpClient, rootUrl: string, params?: ApiPlanSavePlanPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanSavePlanPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanSavePlanPatch.PATH = '/api/Plan/SavePlan';
